export abstract class QueryModel {
  abstract type: string;
}
